import React from "react";
import "./PlayInstruction.scss";
import {
	MDBBox,
	MDBContainer,
	MDBNav,
	MDBTabContent,
	MDBTabPane,
	MDBTypography
} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {Fade} from 'react-reveal'
import Reveal from "react-reveal/Reveal";
import {assetUrl} from "../../serviceApi";
import TermsAndConditionContent from "../../component/TermsAndConditionContent/TermsAndConditionContent";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivacyPolicyContent from "../../component/PrivacyPolicyContent";

const InfoIcon = assetUrl + "images/how-to-play-aboutpng.png";
const LightIcon = assetUrl + "images/how-to-play-skillpng.png";
const VideoIcon = assetUrl + "images/how-to-play-video.png";
const PlusIcon = assetUrl + "images/plus-icon.svg";
const Demo = assetUrl + "images/how-to-play-demo.png";

class PlayInstruction extends React.Component {
	state = {
		activeItem: "1"
	};

	toggle = tab => e => {
		if (this.state.activeItem !== tab) {
			this.setState({
				activeItem: tab
			});
		}
	};

	render() {
		return (
			<MDBBox className="play-instruction-component pb-4">
				{/*<SubPageHeader title="How To Play" show_action={true}/>*/}
				<TopNavSubpage heading="Game Rules" wallet={false} notify={false} border={false}/>
				<MDBBox className={" mb-5"}>
					<MDBNav className="nav-tabs flex-nowrap">
						<MDBBox className="nav-item">
							<a className={this.state.activeItem === "1" ? `nav-link active` : "nav-link"}
							   onClick={this.toggle("1")} role="tab">
								About
							</a>

							{this.state.activeItem === "1" && <Reveal effect="slideInLeft" effectOut="SlideOutRight">
								<hr className={"active-tab-bottomLine"}/>
							</Reveal>}

						</MDBBox>
						<MDBBox className="nav-item">
							<a className={this.state.activeItem === "2" ? `nav-link active` : "nav-link"}
							   onClick={this.toggle("2")} role="tab">
								Game Rules & Pricing System
							</a>
							{this.state.activeItem === "2" && <Reveal effect="slideInLeft" effectOut="SlideOutRight">
								<hr className={"active-tab-bottomLine"}/>
							</Reveal>}
						</MDBBox>
						{/*<MDBBox className="nav-item">*/}
						{/*	<a className={this.state.activeItem === "3" ? `nav-link active` : "nav-link"}*/}
						{/*	   onClick={this.toggle("3")} role="tab">*/}
						{/*		Pricing System*/}
						{/*	</a>*/}
						{/*	{this.state.activeItem === "3" &&*/}
						{/*	<Reveal effect="slideInLeft" effectOut="SlideOutRight" duration={500}>*/}
						{/*		<hr className={"active-tab-bottomLine"}/>*/}
						{/*	</Reveal>}*/}

						{/*</MDBBox>*/}
						<MDBBox className="nav-item">
							<a className={this.state.activeItem === "3" ? `nav-link active` : "nav-link"}
							   onClick={this.toggle("3")} role="tab">
								Terms & Conditions
							</a>
							{this.state.activeItem === "3" &&
							<Reveal effect="slideInLeft" effectOut="SlideOutRight" duration={500}>
								<hr className={"active-tab-bottomLine"}/>
							</Reveal>}

						</MDBBox>
						<MDBBox className="nav-item">
							<a className={this.state.activeItem === "4" ? `nav-link active` : "nav-link"}
							   onClick={this.toggle("4")} role="tab">
								Privacy Policy
							</a>
							{this.state.activeItem === "4" &&
							<Reveal effect="slideInLeft" effectOut="SlideOutRight" duration={500}>
								<hr className={"active-tab-bottomLine"}/>
							</Reveal>}

						</MDBBox>
					</MDBNav>
					<MDBTabContent activeItem={this.state.activeItem}>
						<MDBTabPane tabId="1" role="tabpanel">
							<MDBContainer className="py-4 px-0">
								<AboutSection/>
								{/*<hr className={"content-divider"}/>*/}
								{/*<SkillsAndAbilitySection/>*/}
								{/*<hr className={"content-divider"}/>*/}
								{/*<DemoSection/>*/}
							</MDBContainer>
						</MDBTabPane>
						<MDBTabPane tabId="2" role="tabpanel">
							<p className="description mt-2" >
								The Neta app uses a rather simple pricing mechanism which is based on the popular
								‘Constant Product’ Automated Market Maker (AMM).

								<br/>
								<br/>

								The price of a share of a politician is directly proportional to the number of shares
								that are purchased by the users of the Neta app. Hence, if a politician’s share is in
								high demand, their price will be higher. Consider the math below:

								<br/>
								<br/>
								<ol>
									<li>The initial price of the politician’s share is, lets say, Rs 10. The total number of
										shares of this politician is say 1000. The product of these 2 numbers is a constant K=
										1000x10=10000.
										</li>
									<br/>
									<li>
										Now, if a user buys 100 shares of this politician, then the number of shares left is
										1000-100=900. Now, to maintain the same constant K, the price will have to increase =
										K/900 = 10000/900 = 11.11.

									</li>
								</ol>



								<br/>
								<br/>

								As you can see, the price increased when the shares were in demand. If these shares are
								then sold, the price will then fall back to Rs. 10.

								<br/>
								<br/>

								This simple automated market maker math is identical to one used in modern financial and
								crypto exchanges.

								<br/>
								<br/>

								Neta app is not a bank, and only facilitates peer to peer buy-sell transactions on the
								app.

								<br/>
								<br/>

								The Neta app charges a nominal fees when you withdraw your profits from the app. Other
								than that, Neta app will not charge any fees whatsoever.
							</p>

						</MDBTabPane>
						<MDBTabPane tabId="3" role="tabpanel">
							<br/>
							<TermsAndConditionContent/>
						</MDBTabPane>
						<MDBTabPane tabId="4" role="tabpanel">
							<br/>
							<PrivacyPolicyContent/>
						</MDBTabPane>
						{/*<MDBTabPane tabId="5" role="tabpanel">*/}
						{/*	<p className="mt-2">*/}
						{/*		Quisquam aperiam, pariatur. Tempora, placeat ratione porro*/}
						{/*		voluptate odit minima. Lorem ipsum dolor sit amet,*/}
						{/*		consectetur adipisicing elit. Nihil odit magnam minima,*/}
						{/*		soluta doloribus reiciendis molestiae placeat unde eos*/}
						{/*		molestias.*/}
						{/*	</p>*/}
						{/*</MDBTabPane>*/}
					</MDBTabContent>
				</MDBBox>
				{/*<MDBBox className="bottom-navbar">*/}
				{/*	<BottomNav/>*/}
				{/*</MDBBox>*/}
			</MDBBox>
		);
	}
}

export default PlayInstruction;

class AboutSection extends React.Component {
	render() {
		return (
			<MDBBox className="about-section">
				<Fade cascade>
					<Header title="About NETA" icon={InfoIcon}/>
					<MDBTypography tag="p" className="description pt-3">
						Neta app is a ‘political stock exchange’, a platform on top of which one can trade ‘political
						futures’. A user can invest in a specific politician by purchasing shares of that politician,
						much like one invests in a company stock like Reliance.
						<br/>
						<br/>
						Overtime, as that politician’s career plays out, so will the value of his shares. If one invests
						intelligently and in the right politicians whose approval & popularity rises, so will their
						share price, and this can lead to a certain profit.
						<br/>
						<br/>
						The core objective of the political stock exchange is to keep the leaders accountable and track
						their performance using this gamified system.
					</MDBTypography>
				</Fade>
			</MDBBox>
		);
	}
}

class SkillsAndAbilitySection extends React.Component {
	render() {
		return (
			<MDBBox className="skills-section mt-3">

				<Header title="Required skills and abilities" icon={LightIcon}/>
				<Fade cascade>
					<ul className="pt-3 px-0">

						<li className="description d-flex align-items-baseline">
							<MDBBox className="list-style mr-2"/>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit.
						</li>
						<li className="description d-flex align-items-baseline">
							<MDBBox className="list-style mr-2"/>
							Elementum morbi nisi ultricies orci gravida et lectus libero, elementum.
						</li>
						<li className="description d-flex align-items-baseline">
							<MDBBox className="list-style mr-2"/>
							At pellentesque fusce mauris libero, donec massa cursus.
						</li>
						<li className="description d-flex align-items-baseline">
							<MDBBox className="list-style mr-2"/>
							Enim libero, lorem maecenas convallis at.
						</li>
					</ul>
				</Fade>

			</MDBBox>
		);
	}
}

class DemoSection extends React.Component {
	render() {
		return (
			<MDBBox className="demo-section mt-3">
				<Header title="Watch our Demo Video" icon={VideoIcon}/>
				<img src={Demo} alt="demo" style={{width: "100%"}} className="img-fluid my-3"/>
				<MDBTypography tag="p" className="description pb-3">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elementum morbi nisi ultricies orci gravida
					et lectus libero, elementum. At pellentesque fusce mauris libero, donec massa cursus.
				</MDBTypography>
			</MDBBox>
		);
	}
}

class Header extends React.Component {
	render() {
		return (
			<MDBBox className="d-flex justify-content-between align-items-center header-section">
				<MDBBox className="d-flex align-items-center">
					<MDBBox className="icon-section">
						<img src={this.props.icon} alt="icon"/>
					</MDBBox>
					<MDBTypography tag="p" className="m-0 title">{this.props.title}</MDBTypography>
				</MDBBox>
				{/*<MDBBox>*/}
				{/*	<img src={PlusIcon} alt="icon"/>*/}
				{/*</MDBBox>*/}
			</MDBBox>
		);
	}
}